import { fetchSolanaRpc } from "@/lib/solanaRpc";

export interface WalletPosition {
  uiAmount: number;
  uiAmountString: string;
}

/**
 * Fetches the current live on-chain SPL token balance for a specific wallet and mint.
 */
export async function fetchWalletPosition(wallet: string, mint: string): Promise<WalletPosition | null> {
  try {
    const res = await fetchSolanaRpc({
      jsonrpc: "2.0",
      id: 1,
      method: "getTokenAccountsByOwner",
      params: [
        wallet,
        { mint: mint },
        { encoding: "jsonParsed" }
      ]
    });

    if (!res.ok) {
      console.warn(`[WalletPosition] RPC error ${res.status}`);
      return null;
    }

    const data = await res.json() as any;
    
    if (data.error) {
      console.warn(`[WalletPosition] RPC returned error:`, data.error);
      return null;
    }

    const accounts = data.result?.value;
    if (!accounts || accounts.length === 0) {
      return { uiAmount: 0, uiAmountString: "0" };
    }

    // Usually there is only one Associated Token Account for a given mint
    const tokenAmount = accounts[0]?.account?.data?.parsed?.info?.tokenAmount;
    if (tokenAmount) {
      return {
        uiAmount: tokenAmount.uiAmount || 0,
        uiAmountString: tokenAmount.uiAmountString || "0",
      };
    }

    return null;
  } catch (err) {
    console.error(`[WalletPosition] Failed to fetch position for ${wallet} / ${mint}:`, err);
    return null;
  }
}
